// ip 正则
export const ipRegexp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;

// 密码正则 最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
export const pwdRegexp = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;

// 用户名正则，4到16位（字母，数字，下划线，减号）
export const accountRegexp = /^[a-zA-Z0-9_-]{4,16}$/;

//手机号码校验 三网号码号段
export const phoneRegexp = /^(13[0-9]\d{8}|14[4-9]\d{8}|15[0-35-9]\d{8}|17[0-9]\d{8}|18[0-9]\d{8}|19[0-9]\d{8})$/;
// 广州电信号码号段 前缀
export const gzdxTopPhoneRegexp = /^(133|149|153|189|180|181|173|177|191|199)[0-9]{8}$/g;
//电信号段
export const dxPhoneRegexp = /^(13[0-9]\d{8}|15[0-35-9]\d{8}|17[0-9]\d{8}|18[0-9]\d{8}|191\d{8}|199\d{8}|14[57]\d{8})$/;
// 广州电信固话号码
export const gzdxFixedPhoneRegexp = /^(2338\d{4}|2388\d{4}|26\d{6}|3\d{7}|44\d{6}|8\d{7})$/;

/**
 * 校验ip 是否正确，true 正确
 * @param ip ip地址
 */
export function validateIP(ip) {
    if (ip == null || ip === '') {
        return false;
    }
    return ipRegexp.test(ip);
}

/**
 * 去除字符串前后空格
 * @param str 字符串
 * @returns {*} true 校验通过
 */
export function trim(str) {
    return str.replace(/^\s*|\s*$/g, '');
}

/**
 * 密码强度正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
 * @param password
 * @returns {boolean} true 校验通过
 */
export function passwordValid(password) {
    return pwdRegexp.test(password);
}

/**
 * 用户名正则，4到16位（字母，数字，下划线，减号
 * @param account
 * @returns {boolean} true 校验通过
 */
export function accountValid(account) {
    return accountRegexp.test(account);
}

/**
 * 生成密钥
 *
 * @param length 指定长度，默认32
 * @param char 指定字符集，不指定，则采用默认的
 * @returns {string}
 */
export function generateKey(length = 32, char = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678") {
    // length = length || 32;
    // /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    // char = char || 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = char.length;
    let key = '';

    for (let i = 0; i < length; i++) {
        key += char.charAt(Math.floor(Math.random() * maxPos));
    }
    return key;
}

/**
 * 根据指定的长度 分割字符串
 * @param {Object} value 字符串
 * @param {Object} num 长度
 */
export function changeStr(value, num) {
    let arr = [];
    // let count = 0;
    for (let i = 0, len = value.length / num; i < len; i++) {
        let str1 = value.substr(0, num);
        value = value.replace(str1, '');
        arr.push(str1)
    }
    return arr
}

/**
 * 获取uuid
 * @returns {string}
 */
export function getUuid() {
    return ("a" + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
}

/**
 * 获取随机数
 * @returns {string}
 * @constructor
 */
export function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isObject = arg0 => {
  return arg0 !== null && typeof arg0 === 'object'
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isArray = arg0 => {
  if (arg0 === null || typeof arg0 === 'undefined') {
    return false
  }

  return Object.prototype.toString.call(arg0) === '[object Array]'
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isFunction = arg0 => {
  return typeof arg0 === 'function'
}

/**
 * @param arg0
 * @returns {boolean|boolean}
 */
export const isNumber = arg0 => {
  return typeof arg0 === 'number' && !isNaN(arg0)
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isBoolean = arg0 => {
  return typeof arg0 === 'boolean'
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isString = arg0 => {
  return typeof arg0 === 'string'
}

/**
 *  @param ms
 * */

export const delay = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * @param arg0
 * @returns {boolean}
 */
export const isEmpty = arg0 => {
  if (arg0 === null || typeof arg0 === 'undefined') {
    return true
  }

  if (isString(arg0)) {
    return arg0 === ''
  }

  if (isArray(arg0)) {
    return arg0.length < 1
  }

  if (isObject(arg0)) {
    // noinspection LoopStatementThatDoesntLoopJS
    for (let pn in arg0) {
      return false
    }

    return true
  }

  return false
}

export const datetimeFormat = (p0, format) => {
  if (!isString(format) || isEmpty(format)) {
    format = 'Y-m-d H:i:s'
  }

  let d1 = null

  if (isString(p0)) {
    if (/^\d+$/.test(p0)) {
      try {
        d1 = new Date(parseInt(p0) * 1000)
      } catch (ex) {
        d1 = null
      }
    } else {
      try {
        d1 = new Date(str2timestamp(p0) * 1000)
      } catch (ex) {
        d1 = null
      }
    }
  } else {
    d1 = p0
  }

  if (!isObject(d1) || d1.constructor != Date) {
    return ''
  }

  const year = `${d1.getFullYear()}`
  const month = d1.getMonth() + 1
  const date = d1.getDate()
  const hours = d1.getHours()
  const minutes = d1.getMinutes()
  const seconds = d1.getSeconds()
  const weekDayIdx = d1.getDay()
  const weekDayNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  const sb = []

  for (let i = 0; i < format.length; i++) {
    const c1 = format.charAt(i)

    switch (c1) {
      case 'Y':
        sb.push(year)
        break
      case 'y':
        sb.push(year.substring(2))
        break
      case 'm':
        sb.push(month < 10 ? `0${month}` : month)
        break
      case 'n':
        sb.push(month)
        break
      case 'd':
        sb.push(date < 10 ? `0${date}` : date)
        break
      case 'j':
        sb.push(date)
        break
      case 'H':
        sb.push(hours < 10 ? `0${hours}` : hours)
        break
      case 'i':
        sb.push(minutes < 10 ? `0${minutes}` : minutes)
        break
      case 's':
        sb.push(seconds < 10 ? `0${seconds}` : seconds)
        break
      case 'w':
        sb.push(weekDayIdx)
        break
      case 'l':
        sb.push(weekDayNames[weekDayIdx])
        break
      default:
        sb.push(c1)
        break
    }
  }

  return sb.join('')
}

export const str2timestamp = arg => {
  let ts = parseInt(Date.parse(arg) / 1000)

  if (isNaN(ts)) {
    ts = parseInt(Date.parse(new Date(arg.replace(/-/g, '/'))) / 1000)
  }

  return isNaN(ts) ? 0 : ts
}

/**
 *  过滤特殊字符 防xss
 * */
export const stripscript = str => {
  let pattern = new RegExp("[%--`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")        //格式 RegExp("[在中间定义特殊过滤字符]")
  let result = "";
  for (let i = 0; i < str.length; i++) {
    result = result + str.substr(i, 1).replace(pattern, '');
  }
  return result;
}


export default {
  isEmpty,
  isObject,
  isArray,
  isNumber,
  isString,
  isBoolean,
  delay,
  stripscript
}
